<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row">
          <div class="col-md-1 padding-right-0px padding-left-6px" *ngIf="PatientDetails">
            <img class="img-circle-56 margin-left-10px" [src]="PatientDetails.PatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-2 line-height-17px padding-left-0px padding-right-0px" *ngIf="PatientDetails">
            <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{PatientDetails.DisplayName}}</label>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.FormattedCode}}</label></div>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{PatientDetails.Telephone1}}</label></div>
          </div>
          <!--<div class="col-md-3" *ngIf="PatientDetails">

          </div>-->
          <div class="col-md-7 line-height-17px">
            <!--<label class="margin-bottom-0px">{{ sectionData.Title }}</label>-->
            <label class="margin-bottom-0px font-weight-normal" *ngIf="TemplateName">{{TemplateName}}</label>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal" *ngIf="Date">{{Date|date:'dd-MM-yyyy'}}</label></div>
            <div class="row font-weight-700">
              <!--<div class="col-md-4">
      <label class="font-size-14 font-weight-normal margin-bottom-0px">Section Name</label>
    </div>:-->
              <div class="col-md-12  color-title padding-right-0px">
                <label *ngIf="TitleName" class="font-size-16px font-weight-bold margin-bottom-0px  margin-top-3px">{{TitleName}}</label>

              </div>
            </div>
            <!--<div class="row font-weight-700">
    <div class="col-md-2">
      <label class="font-size-14 font-weight-normal margin-bottom-0px">Sign1</label>
    </div>:
    <div class="col-md-8 font-size-14 font-weight-normal">
      <label *ngIf="Sign1" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign1}}</label>

    </div>
  </div>
  <div class="row font-weight-700">
    <div class="col-md-2">
      <label class="font-size-14 font-weight-normal margin-bottom-0px"> Sign2 </label>
    </div>:
    <div class="col-md-8 font-size-14 font-weight-normal">

      <label *ngIf="Sign2" class="font-size-14 font-weight-normal margin-bottom-0px">{{Sign2}}</label>
    </div>
  </div>-->
          </div>
          <div class="col-md-2">
            <!--<button type="button" class="close float-right" data-dismiss="modal"
          (click)="activeModal.dismiss('Cross click')"
          aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>-->
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>
            <button (click)="onSubmit()" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px">
        <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
          <div class="modal-body padding-top-0px counselling-modal padding-bottom-5px">

            <div class="row">
              <div class="col-md-12 " *ngFor="let field of sectionData.Fields">
                <div class="row" *ngIf="field.ValueType=='Text'">

                  <div class="col-md-12 padding-left-0px">

                    <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" rows="15" placeholder="Remarks"
                              [ngModelOptions]="{standalone: true}"
                              [(ngModel)]="field.Value" maxlength="600"></textarea>

             </div>
                </div>
              </div>
            </div>


            

























          </div>
          <!--<div class="modal-footer float-right col-md-12">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>
          </div>-->
        </form>
      </div>
    </div>
  </div>
</div>
